import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {DebounceClickDirective} from './directives/debounce-click.directive';
import {DebounceInputDirective} from "./directives/debounce-input.directive";
import {FooterComponent} from './components/footer/footer.component';
import {CircleBlockComponent} from './components/circle-block/circle-block.component';
import {LogoComponent} from './components/logo/logo.component';
import {DialogComponent} from './components/dialog/dialog.component';
import {InputErrorComponent} from './components/input-error/input-error.component';
import {DialogErrorComponent} from './components/dialog-error/dialog-error.component';
import {
  CdsBadgeInfoComponent,
  CdsButtonComponent,
  CdsCheckboxComponent,
  CdsInputPlacesComponent, CdsOptionComponent, CdsSelectComponent,
  CdsSvgIconComponent
} from "@carool1/ngx-carool-ds";
import {TransitionPageComponent} from './components/transition-page/transition-page.component';
import {DialogOngoingAnalysisComponent} from './components/dialog-ongoing-analysis/dialog-ongoing-analysis.component';
import {DialogCancelComponent} from './components/dialog-cancel/dialog-cancel.component';
import {TimePickerComponent} from "./components/time-picker/time-picker.component";
import {CookiesConsentComponent} from './components/cookies-consent/cookies-consent.component';
import {AccordionComponent} from './components/accordion/accordion.component';
import {ToggleSwitchComponent} from './components/toggle-switch/toggle-switch.component';
import {RouterLink} from "@angular/router";
import {DialogCookiesComponent} from './components/dialog-cookies/dialog-cookies.component';
import {ShareButtonComponent} from "./components/share-button/share-button.component";
import {ButtonClickListenerDirective} from './directives/button-click-listener.directive';
import {InputListenerDirective} from "./directives/input-listener.directive";
import {HomeButtonComponent} from './components/home-button/home-button.component';
import {RippleDirective} from './directives/ripple.directive';
import {BannerComponent} from "./components/banner/banner.component";


@NgModule({
  declarations: [
    DebounceInputDirective,
    DebounceClickDirective,
    InputListenerDirective,
    FooterComponent,
    CircleBlockComponent,
    DialogComponent,
    InputErrorComponent,
    DialogErrorComponent,
    TransitionPageComponent,
    DialogOngoingAnalysisComponent,
    DialogCancelComponent,
    TimePickerComponent,
    DialogCookiesComponent,
    ShareButtonComponent,
    ButtonClickListenerDirective,
    HomeButtonComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    CdsBadgeInfoComponent,
    CookiesConsentComponent,
    AccordionComponent,
    ToggleSwitchComponent,
    RouterLink,
    RippleDirective,
    BannerComponent,
    LogoComponent,
    CdsSvgIconComponent,
    CdsInputPlacesComponent,
    CdsCheckboxComponent,
    CdsButtonComponent,
    FormsModule,
    CdsSelectComponent,
    CdsOptionComponent
  ],
  exports: [
    TranslateModule,

    // Angular
    CommonModule,
    ReactiveFormsModule,

    // Directives
    DebounceClickDirective,
    InputListenerDirective,
    DebounceInputDirective,
    RippleDirective,

    // Components
    FooterComponent,
    CircleBlockComponent,
    DialogComponent,
    InputErrorComponent,
    DialogErrorComponent,
    TransitionPageComponent,
    DialogOngoingAnalysisComponent,
    TimePickerComponent,

    // Carool DS Module
    CdsBadgeInfoComponent,
    CdsSvgIconComponent,
    DialogCancelComponent,
    AccordionComponent,
    DialogCookiesComponent,
    ButtonClickListenerDirective,
    HomeButtonComponent,
    CdsBadgeInfoComponent,
    CdsInputPlacesComponent,
    CdsCheckboxComponent
  ]
})
export class SharedModule { }
